import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { useGlobalStore } from "@/store/hooks";
import React, { useEffect } from "react";

interface Props {
    shop?: ShopDTO;
    tab: OrderTab;
    checkedValue: OrderTableColumnsType[];
}

/**
 * 加载【预估配送时效】 hooks
 */
const useLogisticsAgingPredictEffect = (props: Props) => {
    const { shop, tab, checkedValue } = props;
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();

    useEffect(() => {
        if (checkedValue?.includes(OrderTableColumnsType.LOGISTICS_AGING_PREDICT)) {
            orderManagementStore.storage.switchShowLogisticsAgingPredict(true);
        } else {
            orderManagementStore.storage.switchShowLogisticsAgingPredict(false);
        }
    }, [checkedValue]);

    useEffect(() => {
        if (orderManagementStore.storage.isShowLogisticsAgingPredict) {
            orderManagementStore.storage.loadLogisticsAgingPredictMapping(
                globalStore,
                orderManagementStore.table.orders,
                shop.id,
                tab,
            );
        }
    }, [orderManagementStore.storage.isShowLogisticsAgingPredict, shop?.id, tab, orderManagementStore.table.orders]);
};

export default useLogisticsAgingPredictEffect;
